<div class="layout-footer">
  <div class="footer-logo-container">
    Powered by
    <img
      alt="BoMa"
      class="ml-2"
      id="footer-logo"
      [src]="
        darkMode == 'dark'
          ? 'assets/layout/images/brand/logo-h-light-text.svg'
          : 'assets/layout/images/brand/logo-h-dark-text.svg'
      "
    />
  </div>
  <span class="copyright">&#169; Boma - {{ year }}</span>
</div>
